module.exports = __webpack_public_path__ + "img/img34.acd9476.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/02/img34.png
// module id = 212
// module chunks = 0